export default {
  GET_APP_TRAINING_VIDEO_HTML: 'GET_APP_TRAINING_VIDEO_HTML',
  GET_APP_TRAINING_VIDEO_HTML_REQUEST: 'GET_APP_TRAINING_VIDEO_HTML_REQUEST',
  GET_APP_TRAINING_VIDEO_HTML_SUCCESS: 'GET_APP_TRAINING_VIDEO_HTML_SUCCESS',
  GET_APP_TRAINING_VIDEO_HTML_FAILURE: 'GET_APP_TRAINING_VIDEO_HTML_FAILURE',

  RESET_APP_TRAINING_VIDEO_STATE: 'RESET_APP_TRAINING_VIDEO_STATE',
};
